import * as React from "react"
import { SvgComponentProps } from "../types/SVGPropType"
const WikiSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={23}
    fill="none"
    {...props}
  >
    <rect
      width={21.802}
      height={21.802}
      x={0.884}
      y={0.59}
      fill="#fff"
      rx={10.901}
    />
    <path
      fill="#0C1518"
      fillRule="evenodd"
      d="M7.936 8.22H6.743c-.34 0-.409.163-.409.342 0 .319.404 1.902 1.883 3.995.985 1.43 2.374 2.205 3.637 2.205.758 0 .852-.173.852-.469v-1.08c0-.344.072-.413.312-.413.177 0 .48.089 1.188.778.808.817.941 1.184 1.396 1.184h1.193c.34 0 .511-.173.413-.513-.108-.338-.494-.83-1.006-1.411-.278-.332-.695-.69-.821-.868-.178-.23-.127-.332 0-.536 0 0 1.453-2.068 1.604-2.77.077-.255 0-.443-.36-.443h-1.193a.515.515 0 0 0-.519.34s-.606 1.494-1.466 2.464c-.278.281-.404.37-.556.37-.075 0-.185-.089-.185-.344V8.664c0-.306-.088-.443-.34-.443H10.49c-.19 0-.303.142-.303.277 0 .29.43.357.473 1.174v1.774c0 .39-.069.46-.22.46-.405 0-1.388-1.5-1.972-3.216-.114-.334-.229-.469-.533-.469Z"
      clipRule="evenodd"
    />
  </svg>
)
export default WikiSVG
